var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104804",
    "data-name": "Group 104804",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104804-2",
    "data-name": "Group 104804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_64254",
    "data-name": "Path 64254",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H136a4,4,0,0,1,4,4V136a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4 1 C 2.345794677734375 1 1 2.345794677734375 1 4 L 1 136 C 1 137.6542053222656 2.345794677734375 139 4 139 L 136 139 C 137.6542053222656 139 139 137.6542053222656 139 136 L 139 4 C 139 2.345794677734375 137.6542053222656 1 136 1 L 4 1 M 4 0 L 136 0 C 138.2091217041016 0 140 1.790847778320312 140 4 L 140 136 C 140 138.2091217041016 138.2091217041016 140 136 140 L 4 140 C 1.790847778320312 140 0 138.2091217041016 0 136 L 0 4 C 0 1.790847778320312 1.790847778320312 0 4 0 Z",
    stroke: "none",
    fill: "#2ae57b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(69.962 116.508)",
    fill: "#2ae57b",
    fontSize: 11,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.188,
    y: 0
  }, "Templates")), /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate_black_24dp",
    transform: "translate(33.561 24.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H72.877V72.877H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79017",
    "data-name": "Group 79017",
    transform: "translate(4.476 2.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146326",
    "data-name": "Rectangle 146326",
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#29e67c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 60,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62,
    height: 59,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x2: 31.5,
    transform: "translate(63 34) rotate(180)",
    fill: "none",
    stroke: "#2ce47a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    y2: 60,
    transform: "translate(31.5 64) rotate(180)",
    fill: "none",
    stroke: "#2ce47a",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/Templates.e2fc8c18089174b08d05daedd2a20822.svg";
export { ForwardRef as ReactComponent };